import React, {Component} from 'react';
import Select from 'react-select';

import 'react-select/dist/react-select.css';

const ServiceCategories = (props) => {
    return (
        <div className="form-group row">
            <label className="col-sm-2 col-form-label"><b>Kategori</b></label>
            <div className="col-sm-10">
                <Select
                    {...props}
                    value={props.input.value}
                    options={props.options}
                    onChange={(value) => props.input.onChange(value)}
                    placeholder={'Vælg kategorier'}
                    multi={true}
                    clearable={false}
                    onBlur={() => props.input.onBlur(props.input.value)}
                />
            </div>
        </div>
    );
};

export default ServiceCategories;




// WEBPACK FOOTER //
// ./web/src/components/services/ServiceCategories.jsx